import {
  SHOW_SUCCESS_SNACKBAR,
  SHOW_WARNING_SNACKBAR,
  SHOW_ERROR_SNACKBAR, 
  SHOW_INFO_SNACKBAR,   
  HIDE_SNACKBAR,
} from "./actionTypes";

const initialState = {
  open: false,
  title: "",
  subtitle: "",
  type: null,
  autoClose: true,         
  autoCloseDuration: 5000,
};

const customSnackbarReducer = (state = initialState, action) => {
  switch (action.type) {
    case SHOW_SUCCESS_SNACKBAR:
      return { ...state, ...action.payload, open: true, type: "success" };
    case SHOW_WARNING_SNACKBAR:
      return { ...state, ...action.payload, open: true, type: "warning" };
    case SHOW_ERROR_SNACKBAR:
      return { ...state, ...action.payload, open: true, type: "error" };
    case SHOW_INFO_SNACKBAR:
      return { ...state, ...action.payload, open: true, type: "info" };
    case HIDE_SNACKBAR:
      return {
        ...initialState,
        open: false,
        type: null, // remove the current type
      };
    default:
      return state;
  }
};

export default customSnackbarReducer;
